import axios, { AxiosRequestConfig } from 'axios';

import { FETCHING_COMPLETE, IS_FETCHING } from '@actions/appState';

import { getIdToken } from '@utils/AuthUtil';

import store from '../store';

const S3_BASE_URL = `${process.env.AWS_S3_BASE_URL}`;
const BASE_URL = `${process.env.API_URL}/`;

export function s3uploadFile(body: any, file: any, onUploadProgress?: any, hideLoadingWidget: boolean = true) {
  const mandatoryHeaders = {};
  const requestHeaders = Object.assign({}, mandatoryHeaders);
  const requestBody = new FormData();

  body.forEach((v: any, k: any) => {
    requestBody.append(k, v);
  });

  requestBody.append('file', file);

  const config: AxiosRequestConfig = {
    method: 'post',
    data: requestBody,
    headers: requestHeaders,
    url: S3_BASE_URL,
    onUploadProgress,
    responseType: 'document',
  };

  if (!hideLoadingWidget) {
    store.dispatch({ type: IS_FETCHING, hideLoadingWidget });
  }

  return axios
    .request(config)
    .then((response: any) => {
      if (!hideLoadingWidget) {
        store.dispatch({ type: FETCHING_COMPLETE, hideLoadingWidget });
      }
      // TODO
      // Get the expected response status from the action.
      if (response.status !== 200 && response.status !== 201) {
        throw Error(response.statusText);
      }

      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export function s3signedUrl(authenticated: boolean, fileName: string) {
  const token = getIdToken() || null;
  const mandatoryHeaders: any = {
    'Content-Type': 'application/json',
  };

  const requestHeaders = Object.assign({}, mandatoryHeaders);
  const config = {
    method: 'get',
    params: { operation: 'CASE_ATTACHMENT', filename: fileName },
    headers: requestHeaders,
    url: `${BASE_URL}agencies/1/s3/signed-url`,
  };

  if (authenticated) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      throw new Error('No token saved!');
    }
  }

  return axios
    .request(config)
    .then((response: any) => {
      // TODO
      // Get the expected response status from the action.
      if (response.status !== 200 && response.status !== 201) {
        throw Error(response.statusText);
      }

      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}
